import { useRouter } from 'next/router';
import getPostTypeStaticProps from '@/functions/wp/posts/getPostTypeStaticProps';
import getPagePropTypes from '@/lib/wp/pagePropTypes';
import parseQuerystring from '@/lib/wp/parseQueryString'
import Container from '@/components/Container';
import Layout from '@/components/Layout';
import SearchResults from '@/components/SearchResults';
import BlockArticleColumns from '@/components/BlockArticleColumns';


const postType = 'page';

/**
 * Render the Search component.
 *
 * @param  {object}  props      The component attributes as props.
 * @param  {object}  props.post Post data from WordPress.
 * @return {Element}            The Search component.
 */
export default function Search({post}) {
  const router = useRouter();
  const path = router?.asPath; // URL from router.
  const query = path.includes('q=') ? parseQuerystring(path, 'q') : ''; // Parse the querystring.

  return (
    <Layout seo={{...post?.seo}}>
      <Container condensed>
        <SearchResults query={query} />
      </Container>
      <Container>
        <BlockArticleColumns columns={4} manualSelect={false} title="More for you" showRecent={true} />
      </Container>
    </Layout>
  );
}

/**
 * Get post static props.
 *
 * @return {object} Post props.
 */
export async function getStaticProps() {
  return await getPostTypeStaticProps(null, 'search');
}

Search.propTypes = {
  ...getPagePropTypes(postType)
};
